/* eslint-disable */
export const errorConfig = {
  ERROR_IN_SENDING_SMS: 'Failed to send SMS OTP. Please try again.',
  OTP_SEND_LIMIT_EXCEEDED:
    'You exceeded the OTP limit. Please try again after 10 minutes.',
  ERROR_IN_SENDING_EMAIL: 'Failed to send email OTP. Please try again.',
  NO_SAVED_OTP_FOUND: 'OTP expired. Please resend OTP and try again.',
  INVALID_OTP: 'Please enter a valid OTP',
  OTP_VALIDATE_LIMIT_EXCEEDED:
    'You exceeded the OTP validation limit. Please try again in 10 minutes.',
  INVALID_MOBILE: 'Something went wrong. Please try again.',
  DOMAIN_NOT_SUPPORTED: 'Something went wrong. Please try again',
  USER_NOT_FOUND:
    'Sorry we cannot find Cleartrip account linked with this phone number',
  COUNTRY_CODE_OR_MOBILE_NOT_FOUND_FOR_SIGNED_IN_USER:
    'Please sign up with a phone number registered on WhatsApp',
  ID_ALREADY_VERIFIED_WITH_SAME_DETAILS_AND_TYPE:
    'This number is already verified',
  USER_ALREADY_EXISTS_FOR_MOBILE: 'An account with this mobile already exist. ',
  MOBILE_ALREADY_VERIFIED: 'Mobile number is already verified.',

  EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE:
    'This email ID is already linked to a different mobile number',
  ACCOUNT_MERGE_LIMIT_EXCEEDED:
    'Account can only be merged once you have exceeded the limit.',
  USER_ALREADY_EXISTS_FOR_EMAIL: 'An account with this Email ID already exists',
  EMAIL_ALREADY_VERIFIED: 'Email is already verified.',

  default: 'Something went wrong. Please try again.'
}
